import * as api from '../../api/api-antecedentes-judiciales-modal';
import { 
    GET_CONFIG_FORM27,
    GET_DATOS_ANTECEDENTES,
    GET_DATOS_GRILLA
    
} from '../types';

export const configuracionFormAction27 = (query) => ({
    type: GET_CONFIG_FORM27,
    payload: api.getConfiguracionForm27(query)
});
export const obtenerDatosAntecedentes = (query) => ({
    type: GET_DATOS_ANTECEDENTES,
    payload: api.getDatosAntecedentes(query)
});
export const obtenerDatosGrilla = (query) => ({
    type: GET_DATOS_GRILLA,
    payload: api.getDatosGrilla(query)
});
